import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TransitionContainer from '../../components/Transition/TranstionContainer';

import VoteRegistrationStep5Form from '../../components/VoteRegistration/VoteRegistrationStep5Form';

import { onGoToStep, saveForm } from './actions';
import { cacheFormData } from '../../utils/formCaching/actions';
import {
    widgetBounce,
    setExitingCardProps,
    getExitingCardProps
} from '../Widget/actions';

import {
    ContainerStyled,
    LegalInfoWrapper,
    FormWrapper
} from '../DefaultStyles/AssessmentDetails';

import { StatesId } from '../../utils/enums';

import VoteRegistrationSidebar from '../../components/VoteRegistration/VoteRegistrationSidebar';

import LegalInfo from '../../components/Widget/LegalInfo';

const VoteRegistrationStep5 = props => (
    <TransitionContainer
        isSubmitting={props.isSubmitting}
        isBackTransition={props.isBackTransition}
        zIndex={28}
    >
        <ContainerStyled>
            <VoteRegistrationSidebar loadRep={true} title={'Voter Registration'} />
            <FormWrapper>
                <VoteRegistrationStep5Form
                    onBack={() => {
                        if (!props.bounceDismissed) {
                            props.widgetBounce(
                                true,
                                props.widgetRequestId,
                                props.articleUrl,
                                props.currentFormValues,
                                props.actionIdentifier
                            );
                        } else {
                            props.setExitingCardProps(
                                'voteRegistration',
                                props,
                                props.activeAction
                            );
                            props.onGoToStep(4, 'back');
                        }
                    }}
                    onSubmit={values => {
                        props.cacheFormData(values);
                        props.setExitingCardProps(
                            'voteRegistration',
                            props,
                            props.activeAction
                        );
                        props.saveForm(values, [6, 7], null, props.formData);
                    }}
                    states={props.states}
                    validationErrors={props.validationErrors}
                />
                {props.isMobileResolution && (
                    <LegalInfoWrapper>
                        <LegalInfo />
                    </LegalInfoWrapper>
                )}
            </FormWrapper>
        </ContainerStyled>
    </TransitionContainer>
);

VoteRegistrationStep5.propTypes = {
    activeAction: PropTypes.object.isRequired,
    onGoToStep: PropTypes.func.isRequired,
    saveForm: PropTypes.func.isRequired,
    formData: PropTypes.object,
    states: PropTypes.array,
    isSubmitting: PropTypes.bool,
    isBackTransition: PropTypes.bool,
    isMobileResolution: PropTypes.bool,
    cacheFormData: PropTypes.func.isRequired,
    setExitingCardProps: PropTypes.func.isRequired,
    bounceDismissed: PropTypes.bool.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    currentFormValues: PropTypes.object.isRequired,
    articleUrl: PropTypes.string.isRequired,
    widgetRequestId: PropTypes.string.isRequired,
    widgetBounce: PropTypes.func.isRequired,
    validationErrors: PropTypes.object
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'voteRegistration',
            ['/voteRegistration/step5'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        return {
            activeAction: state.widget.activeAction,
            formData: state.voteRegistration.formData,
            states: StatesId,
            isSubmitting: state.voteRegistration.isSubmitting,
            isBackTransition: state.voteRegistration.isBackTransition,
            isMobileResolution: state.widget.isMobileResolution,
            actionIdentifier: state.widget.activeAction.identifier,
            bounceDismissed: state.widget.bounceDismissed,
            widgetRequestId: state.widget.widgetRequestId,
            articleUrl: state.widget.articleUrl,
            currentFormValues: (state.form['voteRegistrationStep5Form'] || {}).values,
            validationErrors: (state.form['voteRegistrationStep5Form'] || {}).syncErrors
        };
    },
    { widgetBounce, onGoToStep, saveForm, cacheFormData, setExitingCardProps }
)(VoteRegistrationStep5);
